import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
let k = 1, j = 90;
@Component({
  selector: 'app-manage-customer',
  templateUrl: './manage-customer.component.html',
  styleUrls: ['./manage-customer.component.scss'],
})
export class ManageCustomerComponent {

  loader: boolean = true;
  users;
  Oid;
  Orgid;
  userName;
  search: any = [];
  filterLength;
  change: boolean;
  Id;
  userId;
  dupUsers: any = [];
  type;
  pageEnd: boolean = false;
  scrollResponse: any;
  userLoader: boolean;
  scrollOne: boolean;
  cloneUsers;
  empty: boolean = false;
  orgs: any = [];
  orgName;
  orgId;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public pdf: PdfService,
    public router: Router,
    public bottomSheet: MatBottomSheet,
    public payment: PaymentService,
    public translate: TranslateService,
    public auth: AuthService, public location: LocationService) { }

  ionViewWillEnter() {
    this.Oid = localStorage.getItem('organizationId');
    this.loader = true;
    this.getOrgs();
    k = 1;
    this.getcust();
  }

  getOrgs() {
    this.service.getOrg().subscribe((res: any) => {
      this.orgs = res;
      this.orgs = this.orgs.filter(res => { return res.approvalStatus == 2 && res.activeInd == true })
    })
  }
  getcust() {
    this.service.getUsersByOrg('CUST', this.Oid, null).subscribe(res => {
      this.loader = false;
      this.users = res;
      this.users.map(res => {
        Object.assign(res, { Id: res.userId })
        this.dupUsers = res;
      })
      k++;
    }, err => {
      this.handler.err(err)
      this.loader = false;
    })
  }
  getUser(val) {
    this.empty = false;
    let x = val.length;
    if (x > 0) {
      this.service.searchCustomers("CUST", val, this.Oid).subscribe((res: any) => {
        if (!this.empty) {
          this.cloneUsers = JSON.parse(JSON.stringify(res));
          this.users = JSON.parse(JSON.stringify(res));
        }
        else {
          this.cloneUsers = [];
          this.users = [];
          this.empty = true;
        }
      })
    } else {
      this.empty = true;
      this.cloneUsers = [];
      this.users = [];
      this.users = this.dupUsers;
    }
  }

  openPro(id) {
    this.router.navigate(['editcustomerProfile/', +id])
  }
  // async  onPageScroll($event) {
  //   const scrollElement = await $event.target.getScrollElement();
  //   const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
  //   const currentScrollDepth = $event.detail.scrollTop;
  //   const targetPercent = j;
  //   let triggerDepth = ((scrollHeight / 100) * targetPercent);
  //   if (currentScrollDepth > triggerDepth) {
  //     if (!this.pageEnd) {
  //       this.getcust()

  //     }
  //     k++;
  //   }

  // } 
  details(id) {
    this.router.navigate(['vendorRequests/', +id])
  }

  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res: any) => {
      this.orgName = res.code;
      this.Orgid = res.id;
      this.getcust()
    });
  }

  custItems(id) {
    this.router.navigate(['custItem/', +id])
  }

  tagRoles(id) {
    this.router.navigate(['cust-role-tag/', +id])
  }

  refreshData(event) {
    this.loader = true;
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  items(id) {
    this.router.navigate(['viewItems/', +id])
  }

  ionViewWillLeave() {
    this.search = "";
  }


  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')

  }

  clear() {
    this.search = "";
  }

  onScroll($event) {
    console.log(k);
    this.pageEnd = true;
    if (this.scrollResponse) {
      this.scrollResponse.unsubscribe();
    }
    this.userLoader = false;
    if (!this.userLoader) {
      this.scrollResponse = this.service.getUsersByOrg("CUST", this.Oid, k).subscribe((res: any) => {
        if (res && res.length > 0) {
          this.scrollOne = false;
          this.userLoader = false;
          res.map(dat => {
            this.users.push(dat);
            console.log(this.users);
            this.users = this.users.filter((x, i, a) => a.indexOf(x) == i);
          });
          this.loader = false;
          if (this.users && this.users.length > 0) {
            this.users.sort(function (a, b) {
              if (a.firstName != null && b.firstName != null) {
                var nameA = a.firstName.toLowerCase(), nameB = b.firstName.toLowerCase();
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              }
            });
            k++;
            setTimeout(() => {
              this.pageEnd = false;
            }, 4000);
          }
        } else {
          this.loader = false;
          this.userLoader = false;
          this.scrollOne = true;
        }
      }, err => {
        this.userLoader = false;
        this.scrollOne = true;
        this.pageEnd = false;
      })

    }
  }


}
